import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonDirective } from 'primeng/button';

export interface FileOutdatedModalData {
  loanNumber: string;
  modifiedBy?: string;
}

export type FileOutdatedModalResult = 'refresh' | 'continue';

@Component({
  selector: 'cmg-clear2-ui-file-outdated-modal',
  templateUrl: './file-outdated-modal.component.html',
  styleUrls: ['./file-outdated-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonDirective],
})
export class FileOutdatedModalComponent {
  private readonly _dialogConfig = inject<DynamicDialogConfig<FileOutdatedModalData>>(DynamicDialogConfig);
  private readonly _dialogRef = inject(DynamicDialogRef);

  loanNumber = '';
  modifiedBy = '';

  constructor() {
    this.loanNumber = this._dialogConfig.data?.loanNumber ?? '';
    this.modifiedBy = this._dialogConfig.data?.modifiedBy ?? 'another user';
  }

  refresh(): void {
    this._dialogRef.close('refresh' as FileOutdatedModalResult);
  }

  continueEditing(): void {
    this._dialogRef.close('continue' as FileOutdatedModalResult);
  }
}
